import { forwardRef } from 'react';
import { jsx } from 'react/jsx-runtime';
import { useImage } from '../../utils/image/hooks.js';

const Image = /*#__PURE__*/forwardRef((props, ref) => {
  const ImageComponent = useImage();
  if (ImageComponent) {
    return /*#__PURE__*/jsx(ImageComponent, {
      ref: ref,
      ...props
    });
  }
  const {
    src,
    alt,
    ...rest
  } = props;
  return /*#__PURE__*/jsx("img", {
    src: src,
    alt: alt,
    ...rest
  });
});

export { Image };
